Backbone.Model.prototype.isModel = true;
Backbone.Collection.prototype.isCollection = true;

Backbone.Model.prototype.bindEventToChildren =
	function(options){
		function recur(node, cidsAlreadyBound){ //internal function used to recursively descend through model
			function bindEventsFromHash(eventHash, object){
				for(var key in eventHash){
					if(eventHash.hasOwnProperty(key)){
						object.bind(key, eventHash[key]);
					}
				}
			}

			function unbindEventsFromHash(eventHash, object){
				for(var key in eventHash){
					if(eventHash.hasOwnProperty(key)){
						if(!_(options.previouslyBoundFunction).isUndefined()){
							object.unbind(key, options.previouslyBoundFunction); //HACK -- assumes same function for all events
						}
					}
				}
			}

			if((!_(node).isObject() || _(node).isEmpty()) && !_(node).isArray()){ //If we reached a value, end the recursion
				return;
			}

			if(_(node).isArray()){ //If its an array, descend through every element in the array
				_(node).each(function(element){
					recur(element, cidsAlreadyBound);
				});
				return;
			}

			if(_(node).isObject() && !node.isModel && !node.isCollection){ //vanilla JS object, descend through all of its properties
				for(var key in node){
					if(node.hasOwnProperty(key)){
						recur(node[key], cidsAlreadyBound);
					}
				}
				return;
			}

			if(node.isModel){ //we found a backbone model!
				if(options.modelEvents){
					if(options.unbindFirst){ //if the options passed in specify removing an event first, do that
						unbindEventsFromHash(options.modelEvents, node);
					}

					if(!_(cidsAlreadyBound).include(node.cid)){ //make sure we didn't already bind the event to this model (this is possible if this model is referenced in multiple places)
						cidsAlreadyBound.push(node.cid);
						bindEventsFromHash(options.modelEvents, node); // bind the events
					}
				}
				recur(node.attributes, cidsAlreadyBound); //Recursively descend through all of the models attributes
				return;
			}

			if(node.isCollection){ //we found a backbone collection
				if(options.collectionEvents){	//TODO: its possible that events are bound to the same collection multiple times because collections dont have unique cids
					if(options.unbindFirst){
						unbindEventsFromHash(options.collectionEvents, node);
					}

					bindEventsFromHash(options.collectionEvents, node);
				}
				recur(node.models, cidsAlreadyBound); //descend through all the collection's models
				return;
			}

		}
	recur(this, []); //kick things off
};
